import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../Utils/CommonUtils";
import { setProductFilterForm } from "../../../slices/product/productSlice";
import { PPET_FROM_DATE, PPET_TO_DATE } from "../../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";

const ProductFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.product.filter.form);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setProductFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setProductFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const productCategoryOptions = [
    { value: "insurance", label: "Insurance" },
    { value: "medicolegal", label: "Medicolegal" },
  ];

  const productStatus = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Name..."
                name="filter_ref"
                id="name"
                className="product-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-3">
            <Select
              isClearable
              placeholder="Product Category"
              name="product_category"
              options={productCategoryOptions}
              value={
                productCategoryOptions.find(
                  (itm) => itm.value === filterForm.product_category
                ) || null
              }
              onChange={(e) =>
                handleInputChange("product_category", e ? e.value : "")
              }
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={productStatus}
              value={
                productStatus.find((itm) => itm.value === filterForm.status) ||
                null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default ProductFilter;
